import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react';
import React, { useState } from 'react';
import PrimaryButton from '../../../../Forms/PrimaryButton';
import { datetimeColumn, sharedColumns } from './SharedData';
import ToolsPanel from './ToolsPanel';

const ActualWinnersTable = ({ actualWinners, saveQuote, postUserQuoteLoading, voidWinner }) => {
    const [updatingItem, setUpdatingItem] = useState();
    const [newQuoteText, setNewQuoteText] = useState('');

    const columns = [
        ...sharedColumns,
        {
            name: 'Won',
            key: 'amountWon',
            fieldName: 'amountWon',
            minWidth: 25,
            maxWidth: 50,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        datetimeColumn('Selected On'),
        {
            name: 'Quote',
            key: 'quote',
            fieldName: 'quote',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            isMultiline: true,
        },
        {
            key: 'tools',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item) => {
                return <PrimaryButton onClick={() => setUpdatingItem(item)} text="Tools" />;
            },
        },
    ];

    const dismissPanel = () => {
        setUpdatingItem(null);
        setNewQuoteText('');
    };

    const saveQuoteWrapper = () => {
        saveQuote(updatingItem.userId, newQuoteText.trim()).then(dismissPanel);
    };

    const voidWinnerWrapper = () => {
        voidWinner(updatingItem.userId).then(dismissPanel);
    };

    return (
        <>
            <DetailsList
                items={actualWinners}
                columns={columns}
                selectionMode={SelectionMode.none}
                setKey="userId"
                layoutMode={DetailsListLayoutMode.justified}
            />
            <ToolsPanel
                newQuoteText={newQuoteText}
                setNewQuoteText={setNewQuoteText}
                saveQuoteWrapper={saveQuoteWrapper}
                postUserQuoteLoading={postUserQuoteLoading}
                dismissPanel={dismissPanel}
                updatingItem={updatingItem}
                voidWinnerWrapper={voidWinnerWrapper}
            />
        </>
    );
};

export default ActualWinnersTable;
